import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

export const mainCls = 'csa_button';
const brpM = createBreakpoint('m');

export default {
    [mainCls]: {
        display: 'inline-block',
        width: '100%',
        borderRadius: '3px',
        textDecoration: 'none',
        transition: createTransition(['transform', 'background-color', 'border-color', 'opacity']),

        '&:active': {
            transform: 'perspective(1px) scale(0.98) translate3d(0, 0, 0)',
        },

        '&.is-inactive': {
            opacity: .5,
        },

        [brpM]: {
            '@media (hover: hover)': {
                '&.c-bg--primary:hover': {
                    backgroundColor: '#A30000 !important',
                },
                '&.c-bg--secondary:hover': {
                    backgroundColor: '#1a1f24 !important',
                },            
                '&.c-br--f3:hover': {
                    borderColor: '#39434E !important',
                },
                '&.c-br--border:hover': {
                    borderColor: '#96A1B0 !important',
                },
                '&.c-bg--f5:hover': {
                    backgroundColor: '#39434E !important',
                },
                '&.c-txt--f5:hover': {
                    color: '#39434E !important',
                },
            },
        },
    },
    [`${mainCls}--inline`]: {
        width: 'auto',
    },
    [`${mainCls}-s--s`]: {
        height: '32px',
        lineHeight: '32px',
        padding: '0 24px',

        [brpM]: {
            padding: '0 32px',
        },
    },    
    [`${mainCls}-s--m`]: {
        height: '40px',
        lineHeight: '40px',
        padding: '0 24px',

        [brpM]: {
            padding: '0 32px',
        },
    },
}